var Accordion = (function () {

    var $ = require('jquery');
    var self = {};

    self.init = function () {

        //  Fix for mobile only. Customer wants the accordion closed for mobile.
        if (Foundation.MediaQuery.is('small only')) {

            $('.ce-content-tabber .accordion .is-active').removeClass('is-active');

        }

    };

    return self;

}());

module.exports = Accordion;
